import {useStore} from "vuex";
import {computed} from "vue";
import store from '@/store'

export default function useGeneralLoading() {
    if (!store) {
        throw new Error('Vuex store is not properly initialized');
    }

    return {
        isLoading: computed(() => store.getters['loading/isLoading']),
        isLoadingInitiallyTrue: computed(() => store.getters['loading/isLoadingInitiallyTrue']),
        setLoading: (key, value) => store.dispatch('loading/setLoading', { key, value }),
        removeLoadingKey: (key) => store.dispatch('loading/removeLoadingKey', key),
        hasLoadingKey: (key) => store.getters['loading/hasLoadingKey'](key),
        isKeyLoading: (key) => store.getters['loading/isKeyLoading'](key),
        loadingStates: computed(() => store.state.loading?.loadingStates || {})
    };
}